/**
 * BrandLogo.jsx — the full CardPass lockup (icon + "Card Pass" / "كارد باس").
 * --------------------------------------------------------------------
 * Renders the official brand SVG inline so it inherits `currentColor`
 * (white on dark, black on light — no separate asset swap needed). The
 * mask id is uniquified per instance so multiple logos on one page never
 * collide. Size is driven by a single `height` prop; width keeps ratio.
 */
import React from 'react';
import logoRaw from '../assets/cardpass-logo.svg?raw';

const RATIO = 234.8 / 69.3; // logo viewBox aspect ratio

export default function BrandLogo({ height = 28, className = '', style }) {
  const uid = React.useId().replace(/:/g, '');
  const width = Math.round(height * RATIO);

  const svg = React.useMemo(
    () =>
      logoRaw
        .replace(/id="g"/g, `id="ml${uid}"`)
        .replace(/url\(#g\)/g, `url(#ml${uid})`)
        .replace('<svg ', `<svg width="${width}" height="${height}" `),
    [uid, width, height]
  );

  return (
    <span
      className={`brand-logo ${className}`.trim()}
      aria-label="CardPass"
      style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 0, ...style }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
